module.exports = __webpack_public_path__ + "images/emoji/clock7.77a6fd94fa05e8fa5767.png";